import Zepto from 'zepto-webpack'
import AbstractMonitor from '@/toolbar/inspector/Monitors/AbstractMonitor'
import Events from '@/configuration/Events'

export default class PostAndGetDefined extends AbstractMonitor {
  monitor() {
    const $script = Zepto('script[kr-public-key]')
    if (
      $script.attr('kr-post-url-success') &&
      $script.attr('kr-get-url-success')
    ) {
      this.$store.dispatch('warning', {
        errorCode: 'CLIENT_707',
        metadata: { console: true }
      })
    }
    if (
      $script.attr('kr-post-url-refused') &&
      $script.attr('kr-get-url-refused')
    ) {
      this.$store.dispatch('warning', {
        errorCode: 'CLIENT_708',
        metadata: { console: true }
      })
    }

    return Promise.resolve(true)
  }
}
